/* eslint-disable @typescript-eslint/no-namespace */
export namespace Beziers {
  export type VariantKeys = 'slowStartEase' | 'fastEndEase' | 'endEase';

  export type Variants = {
    [K in VariantKeys]: string;
  };
}

const beziers: Beziers.Variants = {
  slowStartEase: 'cubic-bezier(0.33, 0.00, 0.25, 1.00)',
  fastEndEase: 'cubic-bezier(0.75, 0.00, 0.67, 1.00)',
  endEase: 'cubic-bezier(0.05, 0.00, 0.00, 1.00)',
};

export const bezierVariants = Object.keys(beziers) as Beziers.VariantKeys[];

export default beziers;
